interface DobParts {
  day: number;
  month: number;
  year: number;
}

function parseDob(dob: unknown): DobParts | null {
  if (typeof dob !== 'string') return null;
  const trimmed = dob.trim();
  if (!trimmed) return null;

  const slashParts = trimmed.split('/');
  if (slashParts.length === 3) {
    const day = parseInt(slashParts[0], 10);
    const month = parseInt(slashParts[1], 10);
    const year = parseInt(slashParts[2], 10);
    if (isValidDobParts(day, month, year)) return { day, month, year };
  }

  const dashParts = trimmed.split('-');
  if (dashParts.length === 3 && dashParts[0].length === 4) {
    const year = parseInt(dashParts[0], 10);
    const month = parseInt(dashParts[1], 10);
    const day = parseInt(dashParts[2], 10);
    if (isValidDobParts(day, month, year)) return { day, month, year };
  }

  return null;
}

function isValidDobParts(day: number, month: number, year: number): boolean {
  return (
    Number.isFinite(day) &&
    Number.isFinite(month) &&
    Number.isFinite(year) &&
    day >= 1 &&
    day <= 31 &&
    month >= 1 &&
    month <= 12 &&
    year >= 1900 &&
    year <= 2100
  );
}

export function calculateAgeFromDob(
  dob: unknown,
  referenceDate: Date = new Date()
): number | null {
  const parts = parseDob(dob);
  if (!parts) return null;

  let age = referenceDate.getFullYear() - parts.year;
  const hasHadBirthdayThisYear =
    referenceDate.getMonth() + 1 > parts.month ||
    (referenceDate.getMonth() + 1 === parts.month && referenceDate.getDate() >= parts.day);

  if (!hasHadBirthdayThisYear) age -= 1;

  return age >= 0 && age <= 150 ? age : null;
}

export function formatAgeFromDob(dob: unknown): string {
  if (!dob) return '---';
  const age = calculateAgeFromDob(dob);
  return age != null ? `${age} tuổi` : '---';
}